export const webChannexConstants = {
    WEB_CHANNEX_STATUS_PENDING: 'WEB_CHANNEX_STATUS_PENDING',
    WEB_CHANNEX_STATUS_FULFILLED: 'WEB_CHANNEX_STATUS_FULFILLED',
    WEB_CHANNEX_STATUS_REJECTED: 'WEB_CHANNEX_STATUS_REJECTED',

    WEB_CHANNEX_CONNECT_PENDING: 'WEB_CHANNEX_CONNECT_PENDING',
    WEB_CHANNEX_CONNECT_FULFILLED: 'WEB_CHANNEX_CONNECT_FULFILLED',
    WEB_CHANNEX_CONNECT_REJECTED: 'WEB_CHANNEX_CONNECT_REJECTED',

    WEB_CHANNEX_CLEAR: 'WEB_CHANNEX_CLEAR',
};
